import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BreadCrumbTypography } from 'components/styles_components/typography';
import { PaginateProvider } from 'contexts/paginate';
import IndexContainer from 'components/space_users/index_container';
import BreadcrumbContainer from 'components/breadcrumb_container';
import Container from 'components/layout/container';

const Users = () => {
  return (
    <PaginateProvider>
      <Container>
        <BreadcrumbContainer>
          <BreadCrumbTypography>
            <FormattedMessage id="breadcrumb.users.index" />
          </BreadCrumbTypography>
        </BreadcrumbContainer>
        <IndexContainer />
      </Container>
    </PaginateProvider>
  );
};

export default Users;
